<template>
    <v-dialog v-model="dialog" flat max-width="460" class="lucky-card-dialog">
        <v-row no-gutters>
            <v-spacer />
            <v-col cols="auto">
                <v-btn small icon class="transparent" @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-img :src="config.image2" class="lucky-card-dialog__image" :alt="alt">
            <v-responsive :aspect-ratio="460 / 610">
                <!-- 중복참여시 노출 X -->
                <div>
                    <div class="dialog-spacer" />
                    <router-link to="/mypage/event" target="_blank" class="dialog-button">
                        <v-img src="/images/event/clover/dialog-button.svg" alt="이벤트 참여내역" />
                    </router-link>
                    <v-container>
                        <p class="page-text page-text--small text-center mt-14px">
                            나누리 캐시는 자동지급되며 <br />
                            마이페이지 - 내 캐시내역에서 받기 후 사용하실 수 있습니다.
                        </p>
                    </v-container>
                </div>
            </v-responsive>
        </v-img>
    </v-dialog>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
            dialog: false,
            config: {},
            alt: null,
            alts: [
                {ranking: 1, alt: "1등 A클로버를 뽑았다!"},
                {ranking: 2, alt: "2등 클로버2 카드를 뽑았다!"},
                {ranking: 3, alt: "3등 클로버3 카드를 뽑았다!"},
                {ranking: 4, alt: "4등 클로버4 카드를 뽑았다!"},
                {ranking: 5, alt: "5등 클로버5 카드를 뽑았다!"},
                {ranking: 6, alt: "클로버6 카드를 뽑았다!"},
            ]
        };
    },
    methods: {
        open(config) {
            console.log({config})
            this.alt = this.alts.filter(el => el.ranking === config.ranking)[0].alt
            this.config = config
            this.dialog = true
        },
        close() {
            this.dialog = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-dialog {
        box-shadow: none;
    }
}
.dialog-spacer {
    aspect-ratio: 460 / 450;
}
.dialog-button {
    display: block;
    max-width: calc(160 / 460 * 100%);
    margin: 0 auto;
}
.lucky-card-dialog {
    &__image {
        border-radius: 20px;
    }
}
</style>